module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAcCAYAAABcSP4GAAAAZUlEQVR42mJkV3P6z4AHMDEQACxMfPwEFAgL41fAIiaJXwGzlDQBE2TkKFPA+P//f/wmKNwgoACIKQvJ4aEAFA6MFJtAYZr8++E9fgX/XjzHr+DPk0cUKvj77CkBE17hdwNAgAEAgwYaqI7O2qIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/btfg.png
// module id = +Mbt
// module chunks = 1